angular.module('bmsApp.accounting').factory('PaymentTypeSvc', function (CRUDSvc) {

	return {
		options: function () {
			return CRUDSvc.get('api/paymentType/options');
		}
	};

});